import { render, staticRenderFns } from "./CustomOverWrite.vue?vue&type=template&id=dd047064"
import script from "./CustomOverWrite.vue?vue&type=script&lang=js"
export * from "./CustomOverWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports